export default class ScrollTouch {
    constructor(container) {
        this.mouseMoveEvent = (e) => { this.MouseMoveHandler(e); };
        this.mouseUpEvent = (e) => { this.MouseUpHandler(e); };
        this.mouseDownEvent = (e) => { this.MouseDownHandler(e); };
        this.container = container;
        this.pos = { top: 0, left: 0, x: 0, y: 0 };
        if (this.container) {
            this.container.style.cursor = "grab";
            this.container.addEventListener("mousedown", this.mouseDownEvent);
        }
    }
    MouseDownHandler(e) {
        this.container.style.cursor = "grabbing";
        this.container.style.userSelect = "none";
        this.pos = {
            left: this.container.scrollLeft,
            top: this.container.scrollTop,
            x: e.clientX,
            y: e.clientY,
        };
        document.addEventListener("mousemove", this.mouseMoveEvent);
        document.addEventListener("mouseup", this.mouseUpEvent);
    }
    ;
    MouseMoveHandler(e) {
        // How far the mouse has been moved
        const dx = e.clientX - this.pos.x;
        const dy = e.clientY - this.pos.y;
        // Scroll the element
        this.container.scrollTop = this.pos.top - dy;
        this.container.scrollLeft = this.pos.left - dx;
    }
    ;
    MouseUpHandler(e) {
        this.container.style.cursor = "grab";
        this.container.style.removeProperty("user-select");
        document.removeEventListener("mousemove", this.mouseMoveEvent);
        document.removeEventListener("mouseup", this.mouseUpEvent);
    }
    ;
}
